export default __webpack_public_path__ + "static/img-1-17cd517ef82ff24a64ef13eb8bfca705.png";